import { render } from "./EmptyLayout.vue?vue&type=template&id=e34a5d30"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/EmptyLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e34a5d30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e34a5d30', __exports__)) {
    api.reload('e34a5d30', __exports__)
  }
  
  module.hot.accept("./EmptyLayout.vue?vue&type=template&id=e34a5d30", () => {
    api.rerender('e34a5d30', render)
  })

}


export default __exports__